import { Extension } from '@tiptap/core'
import { LetterSpacingActionMenuButton } from '@/tiptap/extensions/components/ActionMenuButton'

function normalizeLetterSpacing(value) {
  if (value == null) return null
  const raw = String(value).trim()
  if (!raw) return null
  if (/^-?\d+(\.\d+)?(px|em|rem|%)$/.test(raw)) return raw
  if (/^-?\d+(\.\d+)?$/.test(raw)) return `${raw}px`
  return raw
}

export const LetterSpacing = Extension.create({
  name: 'letterSpacing',

  addOptions() {
    return {
      ...(this.parent?.() || {}),
      types: ['textStyle'],
      button: ({ editor, extension, t }) => ({
        component: LetterSpacingActionMenuButton,
        componentProps: { editor, extension, t },
      }),
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          letterSpacing: {
            default: null,
            parseHTML: element => normalizeLetterSpacing(element.style.letterSpacing),
            renderHTML: attrs => {
              const value = normalizeLetterSpacing(attrs.letterSpacing)
              if (!value) return {}
              return { style: `letter-spacing: ${value}` }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setLetterSpacing:
        letterSpacing => ({ chain }) =>
          chain().setMark('textStyle', { letterSpacing: normalizeLetterSpacing(letterSpacing) }).run(),

      unsetLetterSpacing:
        () => ({ chain }) =>
          chain().setMark('textStyle', { letterSpacing: null }).removeEmptyTextStyle().run(),
    }
  },
})

export default LetterSpacing
